import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-solid-svg-icons/faTimes";
import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import cn from "classnames";
import PropTypes from "prop-types";

import "./criterion-indicator.scss";

const CriterionIndicator = ({ label, isConditionMet = false, className }) => {
  const indicatorClassNames = cn(
    "criterion-indicator",
    isConditionMet && "criterion-indicator--satisfied",
    className
  );
  return (
    <div className={indicatorClassNames}>
      <FontAwesomeIcon
        icon={isConditionMet ? faCheck : faTimes}
        aria-hidden="true"
        className="criterion-indicator__icon"
      />
      <span className="criterion-indicator__label" aria-hidden={isConditionMet}>
        {label}
      </span>
    </div>
  );
};

CriterionIndicator.propTypes = {
  label: PropTypes.string.isRequired,
  isConditionMet: PropTypes.bool,
  className: PropTypes.string
};

export default CriterionIndicator;
